<template>
  <div>
    <div v-if="!isMobile" class="search-container">
      <input
        class="search-input mrc-1"
        :class="isOpen ? 'search-input-open mrc-1' : ''"
        id="searchright"
        type="search"
        name="q"
        v-model="search"
        placeholder="Búsqueda de informe o dashboard"
      />
      <label
        class="button mt-1 mrc-1 d-flex justify-content-center align-items-center"
        :class="isOpen ? 'search-button-hidden' : ''"
        for="searchright"
      >
        <span class="mglass">
          <i class="far fa-search"></i>
        </span>
      </label>
    </div>
    <label
      v-else
      class="search-button mrc-1 d-flex justify-content-center align-items-center"
      for="searchright"
      @click="$emit('open-search')"
    >
      <span class="mglass">
        <i class="far fa-search"></i>
      </span>
    </label>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { name as commonModuleName } from '@/modules/common/store'
export default {
  name: 'SearchInput',
  data() {},
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity']
    },
    isOpen() {
      return this.search.length > 0
    },
    search: {
      get() {
        return this.filterText()
      },
      set(value) {
        this.setFilterText(value)
      },
    },
  },
  methods: {
    ...mapActions(commonModuleName, ['setFilterText']),
    ...mapState(commonModuleName, ['filterText']),
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/v2/brand_variables.scss';

.mrc-1 {
  margin-right: 0.2rem !important;
}

.search-container {
  position: relative;
  display: inline-flex;
  margin: -1px 2px 2px 2px;
  height: 50px;
  width: 100%;
  vertical-align: bottom;
}

.search-input {
  display: block;
  margin: 0 0 0 auto;
  background-color: white;
  outline: none;
  border: none;
  padding: 0;
  width: 0px;
  height: 100%;
  font-size: 16px;
  -webkit-transition: width 0.4s linear;
  transition: width 0.4s linear;
  transition-duration: 0.4s;
  -moz-transition-duration: 0.4s;
  -webkit-transition-duration: 0.4s;
  -o-transition-duration: 0.4s;

  &::placeholder {
    color: $dark-gray;
    font-weight: 500;
  }
}

.search-input:focus,
.search-input:hover,
.search-input-open {
  width: 100%;
  padding: 0 16px 0 0;
  padding-left: 2.1rem !important;
  border: 1px solid $orange;
  border-radius: 30px;
  background: url('../../../../assets/img/search.svg') no-repeat left;
  background-size: 22px;
  background-position-x: 6px;

  & > span.mglass {
    display: none;
  }
}

.button {
  height: 45px;
  width: 45px;
  background-color: $orange;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  margin: 4px 2px;
  padding-left: 32px;
  padding-right: 32px;
  line-height: 50px;
  color: white;
  text-decoration: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0;
  padding: 0;
  position: absolute;
  right: 0;
  font-size: 22px;
  transition-duration: 2.1s;
}

.button:hover,
.button:focus {
  transition-duration: 0.4s;
  -moz-transition-duration: 0.4s;
  -webkit-transition-duration: 0.4s;
  -o-transition-duration: 0.4s;
  background-color: white;
  color: white;
  border: 1px solid $orange;
  opacity: 0;
}

.search-button-hidden {
  background-color: white;
  color: white;
  border: 1px solid $orange;
  opacity: 0;
}

.search-input:hover + .button,
.search-input:focus + .button {
  transition-duration: 0.4s;
  -moz-transition-duration: 0.4s;
  -webkit-transition-duration: 0.4s;
  -o-transition-duration: 0.4s;

  @extend .search-button-hidden;
}

input[type='search']::-webkit-search-cancel-button {
  -webkit-appearance: none;
  height: 1em;
  width: 1em;
  border-radius: 50em;
  opacity: 0;
  pointer-events: none;
}

.mglass {
  display: inline-block;
  pointer-events: none;
}

@media screen and (max-width: 767px) {
  .search-button {
    width: 33px;
    height: 33px;
    font-size: 16px;
    background-color: $orange;
    border-radius: 50%;
    cursor: pointer;
    display: inline-block;
    padding-left: 32px;
    padding-right: 32px;
    line-height: 50px;
    color: white;
    text-decoration: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0;
    padding: 0;
  }
}
</style>
